import styled from 'styled-components';

export const ActionWrap = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  .MuiCircularProgress-root {
    display: none;
    margin-right: 5px;
  }

  .MuiSvgIcon-root {
    font-size: 14px;
    margin-right: 5px;
  }

  &.busy {
    .MuiCircularProgress-root {
      display: block;
    }

    .MuiSvgIcon-root {
      display: none;
    }
  }
`;
